export default __webpack_public_path__ + "static/media/pageNotFound.5c889b48.jpg";